import { readIntentHandoff } from './intentHandoff';
import { readPublicLaunchIntent } from './publicLaunchIntent';

const KEY = 'lm_auth_continuation';
const TTL = 24 * 60 * 60 * 1000;
let fallback: { path: string; expires: number } | null = null;

export function safeCabinetPath(value: unknown): string | null {
    if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return null;
    if (
        /[\\\s]/.test(value) ||
        Array.from(value).some((char) => char.charCodeAt(0) < 32) ||
        /%0[ad]|%5c|%2f/i.test(value)
    )
        return null;
    const url = new URL(value, 'https://app.leadsmania.ru');
    if (!/^\/(leadstream(?:\/\d+)?|feed|ai_agents(?:\/[^/:]+)*|integrations|partnership|workspace)$/.test(url.pathname))
        return null;
    return url.pathname + url.search + url.hash;
}

export function rememberAuthDestination(path: string) {
    const safe = safeCabinetPath(path);
    if (!safe) return;
    fallback = { path: safe, expires: Date.now() + TTL };
    try {
        sessionStorage.setItem(KEY, JSON.stringify(fallback));
    } catch {
        /* Same-tab fallback. */
    }
}

export function captureAuthDestination() {
    const path = new URLSearchParams(window.location.search).get('backUrl');
    if (path) rememberAuthDestination(path);
}

export function readAuthDestination(): string | null {
    let saved = fallback;
    try {
        saved = JSON.parse(sessionStorage.getItem(KEY) || 'null') || saved;
    } catch {
        /* Same-tab fallback. */
    }
    return saved && saved.expires > Date.now() ? safeCabinetPath(saved.path) : null;
}

export function clearAuthDestination() {
    fallback = null;
    try {
        sessionStorage.removeItem(KEY);
    } catch {
        /* Optional persistence. */
    }
}

export function pendingEntryDestination(): string | null {
    return readAuthDestination() || (readIntentHandoff('draft') || readPublicLaunchIntent() ? '/leadstream' : null);
}
